export default __webpack_public_path__ + "static/media/ContentImg.b9774404.png";